import { render, staticRenderFns } from "./MessageBar.vue?vue&type=template&id=3b292658"
import script from "./MessageBar.vue?vue&type=script&lang=ts"
export * from "./MessageBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports